<template>
  <div
    class="grid grid-cols-auto-1 gap-3 text-sm p-1 cursor-pointer"
    @click="emitSelection"
    v-if="option"
  >
    <div>
      <icon name="Checkbox" :settings="{ active: localSelected }" />
    </div>
    <div>{{ option.text }}</div>
  </div>
</template>

<script>
import { SurveyOption } from "@/modules/surveys/viewmodels/SurveyOption";

export default {
  name: "SurveyOptionPreview",
  data() {
    return {};
  },
  props: {
    option: {
      type: SurveyOption,
    },
    selectedArray: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  components: {},
  methods: {
    emitSelection() {
      this.$emit("selection", !this.localSelected);
    },
  },
  computed: {
    localSelected() {
      return this.selectedArray.indexOf(this.option.id) !== -1;
    },
  },
  created() {},
};
</script>
